
<template>

    <div class="row free-wrapper">
        <div class="p-30 pb-0" style="overflow: auto; z-index:1; position: relative;">
            <!-- <div class="text-center">
                <img src="/images/SwingUPremiumLogoWhite.png" alt="SwingU Premium">
            </div> -->
            <h3>Give Yourself Every Advantage On And Off The Course</h3>

            <div class="video-wrapper">
                <div class="wistia_embed wistia_async_6465eyh002 seo=false">
                    <div class="wistia_swatch" style="height:100%;left:0;opacity:0;overflow:hidden;position:absolute;top:0;transition:opacity 200ms;width:100%;">
                        <img src="https://fast.wistia.com/embed/medias/6465eyh002/swatch" style="filter:blur(5px);height:100%;object-fit:contain;width:100%;" alt="" aria-hidden="true" onload="this.parentNode.style.opacity=1;" />
                    </div>
                </div>

                <a href="https://checkout.swinguapps.com" target="_blank" class="btn-cta">Join &amp; Save 30% Your First Year</a>
            </div>
            <!-- <div class="screenshot-wrapper">
                <img src="/images/iphonescreenshots.png" alt="iPhone Screenshots">
            </div>
            <div class="benefits-wrapper">
                <ul class="benefits-list">
                    <li>"Plays Like" Yardages</li>
                    <li>Shot Tracking &amp; "Smart" Club Recommendations</li>
                    <li>Hole Insights - Your Stats vs. Other SwingU Golfers, and Hole Notes For Every Course</li>
                    <li>Access to 600+ Lessons &amp; Drills + 12 Personalized Lessons</li>
                    <li>Ad-Free In-App Experience</li>
                </ul>
                <a href="https://checkout.swinguapps.com" target="_blank" class="btn-cta">Join &amp; Save 30% Your First Year</a>
            </div> -->
        </div>
    </div>
</template>

<script>

import axios, { Method } from "axios";

export default {
    props: [],

    data: () => {
        return {
            debugMessages: []
        };
    },

    created: function() {
        this.debug("We loaded the 'no subscription' view");
    },

    methods: {
        debug: function (message) {
            // console.log('DEBUG: ', message);
            // this.debugMessages.push(message);
        }
    }
}
</script>


<style scoped lang="scss">
@import "@/_var.scss";
</style>
